<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name" id="benefitHeader">
                    {{pageTitle}}
                </div>
                <button type="submit" class="back_button btn btn-primary pull-right" v-on:click.prevent="buttonBack">Back</button>
            </div>
            <!--page content-->
            <!--Add Policies and Form section-->
            <div class="admin-page-content">
                <form id="changeProfile">
                    <div class="forms-container">
                        <div class="row no-margin">
                            <!--Location-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="locationId">State :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select multiple
                                              v-model="locationId"
                                              @change="changedValue"
                                              @input="changedValueLocation()"
                                              name="locationId"
                                              id="locationId"
                                              label="text"
                                              :filterable="false"
                                              :options="locationArr"
                                              @search="onSearchLocation"
                                              placeholder="Select State">
                                        <template slot="no-options">
                                            Search State...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{locationError}}</font>
                                </div>
                            </div>
                            <!--Role-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="roleData">Role :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select class=""
                                              v-model="roleId"
                                              name="roleId"
                                              id="roleData"
                                              label="text"
                                              @input="changedValueRole()"
                                              :searchable="false"
                                              :filterable="false"
                                              :options="roleArr"
                                              placeholder="Select Role">
                                    </v-select>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{roleError}}</font>
                                </div>
                            </div>
                            <!--Title-->
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="description">Title :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input v-model="title" type="text" class="form-control" id="title" placeholder="Title" />
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{titleError}}</font>
                                </div>
                            </div>

                            <!--Image-->
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="drop1">Upload Image :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <vue-dropzone
                                        id="drop1"
                                        :options="dropzoneOptions"
                                        ref="dropzone"
                                        :destroyDropzone="false"
                                        :headers="dropzoneOptions.headers"
                                        @vdropzone-removed-file="removedSelectedFile"
                                        @vdropzone-success="vfileSuccess"
                                        @vdropzone-duplicate-file="vduplicateFile"
                                        @vdropzone-total-upload-progress="progressOfUload"
                                        name="file"
                                        >
                                    </vue-dropzone>
                                    <div class="requiredstar">*</div>
                                    <font class="text-danger">{{imageError}}</font>
                                    <font class="text-danger"> <strong id="errorMsg2" class="error"></strong></font>
                                </div>
                            </div>
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="description">Description :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <tinymce :plugins="['advlist autolink lists link image charmap print preview hr anchor pagebreak', 'searchreplace wordcount visualblocks visualchars code fullscreen', 'insertdatetime media nonbreaking save table contextmenu directionality','template paste textcolor colorpicker textpattern imagetools toc help emoticons hr codesample']" id="description" v-model="description" class= "" ref="tm" :other_options="options"></tinymce>
                                    <font class="text-danger">{{descriptionError}}</font>
                                </div>
                            </div>
                            <div class="col-12 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label" for="contactDescription">Contact Description :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <tinymce :plugins="['advlist autolink lists link image charmap print preview hr anchor pagebreak', 'searchreplace wordcount visualblocks visualchars code fullscreen', 'insertdatetime media nonbreaking save table contextmenu directionality','template paste textcolor colorpicker textpattern imagetools toc help emoticons hr codesample']" id="contactDescription" v-model="contactDescription" class= "" ref="tm" :other_options="options"></tinymce>
                                    <font class="text-danger">{{contactDescriptionError}}</font>
                                </div>
                            </div>
                            <!--Error Alert-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <div class="alert alert-danger" id="alertError">
                                        <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>
                            </div>
                            <!--Buttons-->
                            <div class="col-12">
                                <div class="col-12 paddingleft0">
                                    <input id="addBenifitBtn" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addUpdate401kDocs()">
                                    <input id="addAndContinueBenifitBtn" type="submit" value="Save and Continue" class="btn btn-primary" v-on:click.prevent="addUpdate401kDocs(flag='Save and Continue')">
                                    <!--<input id="addMedia" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addUpdate401kDocs()"></input>-->
                                    <input id="CancelBenifit" type="submit" value="Cancel" class="back_button btn btn-primary" v-on:click.prevent="buttonBack">
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--page content-->
                </form>
            </div>
            <!--End Add Section-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    var self;
    import vSelect from 'vue-select';
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import SessioMixin from '../../../mixins/sessionmixin';
    import {HTTP} from '../../../http-common';
    import VueCroppie from 'vue-croppie';
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    import tinymce from 'vue-tinymce-editor';

    Vue.use(VueCroppie);
    export default {
        name: 'Login',
        props: [''],
        mixins: [SessioMixin],
        components: {
            'v-select': vSelect,
            vueDropzone: vue2Dropzone,
            'tinymce': tinymce,
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
                options: {
                    /*language_url: 'http://example.com/js/langs/fa_IR.js' //This url points to location of persian language file.*/
                },
                //DropZone
                dropzoneOptions: {
                    timeout: 3000000,
                    url: process.env.ROOT_API + "/uploadmedia",
                    method: 'POST',
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 50, //MB
                    maxFiles: 1, //ToDo : to decide number of files allowed
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    duplicateCheck: true,
                    acceptedFiles: ".jpg, .jpeg",
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    dictFileTooBig: "File is too big ({{filesize}}mb). Max allowed file size is {{maxFilesize}}mb",
                    dictInvalidFileType: "Invalid File Type",
                    dictCancelUpload: "Cancel",
                    dictRemoveFile: "Remove",
                    dictMaxFilesExceeded: "Only {{maxFiles}} file is allowed",
                    dictDefaultMessage: "Drop files here to upload",
                },

                imageType: '',
                imageSize: '',
                imagePath: '',
                imageWidth: 0,
                imageHeight: 0,
//                V-model
                locationId: '',
                locationArr: [],
                roleId: 0,
                roleArr: [],
                title: '',
                redirectionLink: '',
                contactEmail: '',
                contactNumber: '',
                description: '',
                contactDescription: '',
                pageTitle: 'Add Dayforce101 Docs',

//                FrontEnd Errors
                titleError: '',
                redirectionLinkError: '',
                contactEmailError: '',
                contactNumberError: '',
                descriptionError: '',
                roleError: '',
                locationError: '',
                contactDescriptionError: '',

                imageError: '',
                isFileUploaded: false,
                fileUploaded: true,
//                BackEnd Error
                backendErrors: [],
            }
        },
        mounted: function () {
            self = this;
            self.checkLogin();
            self.loadLocationsAdd();
            self.loadRole();
            self.loadLocations();

            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[2] == 'updatedayforce101docs') {
                if (segments[3]) {
                    self.loadDayforce101Docs();
                    $("#addAndContinueBenifitBtn").hide();
                    $("#addBenifitBtn").val("Update");
                    self.pageTitle = "Edit Dayforce101 Docs";
                }
            }

            $("#title").on('keyup', function () {
                self.titleError = '';
            });
            $("#locationId").on('keyup', function () {
                self.locationError = '';
            });
            $("#roleId").on('keyup', function () {
                self.roleError = '';
            });
            $("#redirectionLink").on('keyup', function () {
                self.redirectionLinkError = '';
            });
            $("#contactEmail").on('keyup', function () {
                self.contactEmailError = '';
            });
            $("#contactNumber").on('keyup', function () {
                self.contactNumberError = '';
            });


            $("#drop1").on('change', function () {
            });

            $("#alertError").hide();
            $('#main-header').hide();
            $('#main-footer').hide();
            $('html,body,#app').css({
                //height: "100%"
            });
            /*if ($(".login-form-right-section").height() > $(window).height()) {
             $("#login-main-hr").height($(".login-form-right-section").height());
             } else {*/
            $("#login-main-hr").height($(window).height());
            /*}*/
            /*$("#login-main-hr").css({
             height:
             });*/

        },
        watch: {

        },
        methods: {
            buttonBack() {
                $(".back_button").prop("disabled", false);
                self.$router.push('/backend/listdayforce101docs');
            },

            removeAllFiles() {
                self.$refs.dropzone.removeAllFiles();
                self.isFileUploaded = false;
            },

            vfileSuccess: function (file, response) {
                self.imagePath = response.content.media_path;
                self.isFileUploaded = true;
                if ("media_thumb_path" in response.content) {
                    self.mediaThumbnailPaths = response.content.media_thumb_path;
                } else {
                    self.mediaThumbnailPaths.push("");
                    /*console.log("No media thumb");*/
                }
                self.imageType = file.type;
                self.imageSize = file.size;
                self.imageWidth = file.width;
                self.imageHeight = file.height;
                self.imageError = '';
            },

            removedSelectedFile(file, xhr, error) {
                if(file && file.xhr && file.xhr.response){
                    self.isFileUploaded = false;
                    self.imagePath = '';
                    self.imageHeight = 0;
                    self.imageWidth = 0;
                    var filePath = JSON.parse(file.xhr.response);
                    //console.log(file);
                    if ("media_thumb_path" in filePath.content) {
                        //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                        self.removeFileFromServer(filePath.content.media_path, filePath.content.media_thumb_path);
                    } else {
                        //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                        self.removeFileFromServer(filePath.content.media_path, "");
                    }
                }
            },
            removeFileFromServer: function (filePath, thumbnailPath) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        filePath: filePath,
                        thumbnailPath: thumbnailPath
                    }
                };
                HTTP.delete('removemedia', config)
                        .then(function (response) {
                            /*console.log("File removed successfully");*/
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            vduplicateFile: function (file) { // Todo: Understand functionality. Not Working till date.
                /*console.log("Duplicate file" + file.name);*/
            },

            changedValue: function (value) {
                //console.log(value);
            },

            loadLocationsAdd(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var data = {
                    search: search
                };
                HTTP.post("getlocation", data)
                        .then(function (response) {
                            self.locationArr = response.data.content;
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            loadLocations() {
                HTTP.post("/getlocation")
                        .then(function (response) {
                            self.locationArr = response.data.content;
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            changedValueLocation: function () {
                self.locationError = "";
            },
            onSearchLocation(search, loading) {
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadLocationsAdd(loading, search, this);
                }
            },

            loadRole() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post("getroles", '', config)
                        .then(function (response) {
                            self.roleArr = [];
                            $.each(response.data.content, function (i) {
                                self.roleArr.push(response.data.content[i]);
                            });
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                            }
                        });
            },
            changedValueRole() {
                self.roleError = '';
            },

            checkForm: function () {
                var checked = true;
                if (self.locationId.length === 0) {
                    self.locationError = "State Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.roleId) {
                    self.roleError = "Role Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.title) {
                    self.titleError = "Title Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.contactNumber) {
                    if (/^[0-9- ,-]*$/.test(self.contactNumber) == false) {
                        self.contactNumberError = 'Please Enter Valid Contact Number';
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                if (self.contactEmail && !self.validEmail(self.contactEmail)) {
                    self.contactEmailError = 'Please Enter Valid Email';
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.redirectionLink != '' && !self.validUrl(self.redirectionLink)) {
                    self.redirectionLinkError = 'Please Enter Valid URL';
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.isFileUploaded == false) {
                    self.imageError = "Please Upload Image";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.fileUploaded == false) {
                    self.imageError = "Please Wait While Image Is Being Uploaded";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            validUrl: function (url) {
                var re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
                return re.test(url);
            },
            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },

            loadDayforce101Docs() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                var data = {
                    id: segments[3],
                };
                self.showLoader();
                HTTP.post("getdayforce101doc/" + segments[3], data, config)
                        .then(function (response) {
                            /*self.locationId = {
                             value: response.data.content[0].location_id,
                             text: response.data.content[0].location_name,
                             };*/
                            self.locationId = [];
                            for (var i = 0; i < response.data.content[0].location.length; i++) {
                                self.locationId.push({'text': response.data.content[0].location[i].name, 'value': response.data.content[0].location[i].id});
                            }
                            self.roleId = {
                                value: response.data.content[0].role_id,
                                text: response.data.content[0].role_name,
                            };
                            self.title = response.data.content[0].title;
                            self.imagePath = response.data.content[0].image_path;
                            self.redirectionLink = response.data.content[0].redirection_link;
                            self.contactEmail = response.data.content[0].contact_email;
                            self.contactNumber = response.data.content[0].contact_number;
                            self.description = response.data.content[0].description;
                            self.contactDescription = response.data.content[0].contact_description;

                            if (self.imagePath != '') {
                                self.isFileUploaded = true;
                                self.imageSize = response.data.content[0].image_size;
                                self.imageWidth = 1200;
                                self.imageHeight = 450;
                                self.uploadManually();
                                self.imagePath = '';
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },

            uploadManually(file) {
                if (self.imagePath != '') {
                    var file_name = self.getFileName(self.imagePath);
                    let file_type = self.getFileType(file_name);
                    let url = self.imagePath;
                    let file_size = self.imageSize;
                    /*console.log("File Name : " + file_name + " , File Type : " + file_type + " , URL : " + url + " , File Size : " + file_size);*/
                    let file_data = {size: file_size, fileid: file_name, name: file_name, type: file_type};
                    self.$refs.dropzone.manuallyAddFile(file_data, url);
                    /*
                     self.truckFormData.uploadedFiles.push(file_name);*/
                }

            },

            getFileName: function (file) {
                var src = file.split('/');
                var file_name = src[src.length - 1];
                return file_name;
            },
            getFileType: function (file_name) {
                var type = file_name.split('.');
                var file_type = type[type.length - 1];
                return 'image/' + file_type;
            },

            addUpdate401kDocs(flag) {
                /*console.log("Befor form check");*/
                self.checkForm();
                if (self.checkForm()) {
                    /*console.log("form check success");*/
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    var locationsId = '';
                    for (var i = 0; i < self.locationId.length; i++) {
                        locationsId += (self.locationId[i].value) + ',';
                    }
                    locationsId = locationsId.replace(/,\s*$/, "");

                    if (segments[2] == 'updatedayforce101docs') {
                        if (segments[3]) {
                            var data = {
                                roleId: self.roleId.value,
                                locationId: locationsId,
                                title: self.title,
                                redirectionLink: self.redirectionLink,
                                contactEmail: self.contactEmail,
                                contactNumber: self.contactNumber,
                                description: self.description,
                                contactDescription: self.contactDescription,
                                mediaPath: self.imagePath,
                                mediaType: self.imageType,
                                mediaSize: self.imageSize,
                                id: segments[3],
                            };
                            $("#addBenifitBtn").val("Updating ...");
                            $("#addBenifitBtn").prop("disabled", true);
                            // $("#addAndContinueCaseBtn").prop('disabled',true);
                            $("#CancelBenifit").prop("disabled", true);
                        } else {
                            if (flag == "Save and Continue") {
                                $("#addAndContinueBenifitBtn").val("Saving ...");
                                $("#addAndContinueBenifitBtn").prop("disabled", true);
                                $("#addBenifitBtn").prop("disabled", true);
                                $("#CancelBenifit").prop("disabled", true);
                            } else {
                                $("#addBenifitBtn").val("Saving ...");
                                $("#addBenifitBtn").prop("disabled", true);
                                $("#addAndContinueBenifitBtn").prop("disabled", true);
                                $("#CancelBenifit").prop("disabled", true);
                            }
                        }
                    } else {
                        var data = {
                            roleId: self.roleId.value,
                            locationId: locationsId,
                            title: self.title,
                            redirectionLink: self.redirectionLink,
                            contactEmail: self.contactEmail,
                            contactNumber: self.contactNumber,
                            description: self.description,
                            contactDescription: self.contactDescription,
                            mediaPath: self.imagePath,
                            mediaType: self.imageType,
                            mediaSize: self.imageSize,
                        };
                        if (flag == "Save and Continue") {
                            $("#addAndContinueBenifitBtn").val("Saving ...");
                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                            $("#addBenifitBtn").prop("disabled", true);
                            $("#CancelBenifit").prop("disabled", true);
                        } else {
                            $("#addBenifitBtn").val("Saving ...");
                            $("#addBenifitBtn").prop("disabled", true);
                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                            $("#CancelBenifit").prop("disabled", true);
                        }
                    }
                    self.showLoader();
                    HTTP.post("addupdatedayforce101docs", data, config)
                            .then(function (response) {
                                self.removeAllFiles();
                                if (segments[2] == 'updatedayforce101docs') {
                                    if (segments[3]) {
                                        //console.log(segments[3]);
                                        $("#addBenifitBtn").val("Update");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelBenifit").prop("disabled", false);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueBenifitBtn").val("Save and Continue");
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                        } else {
                                            $("#addBenifitBtn").val("Save");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueBenifitBtn").val("Save and Continue");
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                    } else {
                                        $("#addBenifitBtn").val("Save");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                    }
                                }

                                if (response.data.status == "success") {
                                    // self.$router.push('/task/list');
                                    $("#errorMsg").html(response.data.content);
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                    if (flag == "Save and Continue") {
//                                $("html, body").animate({scrollTop: "0px"}, 500);
                                        $(".alert-success").addClass("show");
                                        self.locationId = '';
                                        self.locationArr = [];
                                        self.roleId = '';
                                        self.roleArr = [];
                                        self.title = '';
                                        self.redirectionLink = '';
                                        self.contactEmail = '';
                                        self.contactNumber = '';
                                        self.description = '';
                                        self.contactDescription = '';
                                        self.loadLocationsAdd();
                                        self.loadRole();
                                        self.loadLocations();
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 3000);
                                    } else {
                                        $(".back_button").prop("disabled", true);
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                            self.buttonBack();
                                        }, 3000);
                                    }
                                } else {
                                    $("#alertError").show();
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                    }
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                    }, 5000);
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.removeAllFiles();
                                if (segments[2] == 'updatedayforce101docs') {
                                    if (segments[3]) {
                                        $("#addBenifitBtn").val("Update");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").val("Save and Continue");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            $(".alert-success").removeClass("hide");
                                            $(".alert-success").addClass("show");
                                            self.removeAllFiles();
                                            self.locationId = '';
                                            self.locationArr = [];
                                            self.roleId = '';
                                            self.roleArr = [];
                                            self.title = '';
                                            self.redirectionLink = '';
                                            self.contactEmail = '';
                                            self.contactNumber = '';
                                            self.description = '';
                                            self.contactDescription = '';
                                            self.loadLocationsAdd();
                                            self.loadRole();
                                            self.loadLocations();
                                            $("#status option[value='']").attr('selected', true);
                                            $("#type option[value='']").attr('selected', true);

                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        } else {
                                            $("#addBenifitBtn").val("Save");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                                            $("#CancelBenifit").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }

                                        if (err.response.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/login");
                                            }
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").val("Save and Continue");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        $(".alert-success").removeClass("hide");
                                        $(".alert-success").addClass("show");
                                        self.removeAllFiles();
                                        self.locationId = '';
                                        self.locationArr = [];
                                        self.roleId = '';
                                        self.roleArr = [];
                                        self.title = '';
                                        self.redirectionLink = '';
                                        self.contactEmail = '';
                                        self.contactNumber = '';
                                        self.description = '';
                                        self.contactDescription = '';
                                        self.loadLocationsAdd();
                                        self.loadRole();
                                        self.loadLocations();

                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $("#addBenifitBtn").val("Save");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").prop("disabled", true);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }

                                    if (err.response.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }
                                }
                                self.hideLoader();
                            });
                }

                //
            },
            progressOfUload(totaluploadprogress, totalBytes, totalBytesSent) {
                if (totaluploadprogress == 100) {
                    self.fileUploaded = true;
                    self.imageError = "";
                } else {
                    self.fileUploaded = false;
                }
            }
        }
    }
</script>

<style>
    .disabled {
        pointer-events:none;
        color: #bfcbd9;
        cursor: not-allowed;
        background-image: none;
        background-color: #eef1f6;
        border-color: #d1dbe5;
    }
</style>



// WEBPACK FOOTER //
// src/components/backend/dayforce101docs/AddDayforce101Docs.vue